import { gql } from "@apollo/client"


export const ADD_EMAIL = gql`
  mutation AddEmail($email: String!, $password: String!) {
    AddEmail(email: $email, password: $password) {
      status
      message
      emails {
        _id
        email
        status
      }
    }
  }
`;


export const GET_EMAILS = gql`
  query GetEmails {
    GetEmails {
      _id
      email
      status      
    }
  }
`;

export const DELETE_EMAIL = gql`
  mutation DeleteEmail($email : String!){
    DeleteEmail(email: $email){
      status
      message
    }
  }
`;

export const EDIT_EMAIL = gql`
  mutation EditEmail($_id: ID!, $email : String!, $password: String){
    EditEmail(_id: $_id, email: $email, password: $password){
      status
      message
      emails {
        _id
        email
        status
      }
    }
  }
`

export const UPDATE_EMP_EMAIL_SETTINGS = gql`
  mutation UpdateEmpEmailSettings($employeeId: String!, $emailSettings: [emailSettingsInputType]!){
    UpdateEmpEmailSettings(employeeId: $employeeId, emailSettings: $emailSettings){
      success
      message
      response{
        id
        emailSettings{
          email
          password
          status
        }
      }
    }
  }
`
export const UPDATE_EMP_SHARED_EMAIL_SETTINGS = gql`
  mutation UpdateEmpSharedEmailSettings($employeeId: String!, $sharedemailSettings: [sharedemailSettingsInputType]!){
    UpdateEmpSharedEmailSettings(employeeId: $employeeId, sharedemailSettings: $sharedemailSettings){
      success
      message
      response{
        id
        sharedemailSettings{
          email
          status
        }
      }
    }
  }
`

export const VALIDATE_OUTLOOK = gql`
  mutation ValidateOutlook($email: String!, $password: String!) {
    validateOutlook(email: $email, password: $password) {
      valid
      message
    }
  }
`;